import React, { useEffect, useState } from 'react';
import './style.scss';
import useApi from "../../hooks/useApi";
import Preloader from "../Preloader";
import isEqual from "lodash/isEqual";
import Checkbox from "../core/Checkbox";
import { SfControls } from "../../pages/Crm/columns";
import Table from "../core/Table";
import Dropdown from "../core/Dropdown";
import uniq from "lodash/uniq";
import without from "lodash/without";
import useClickPast from "../../hooks/useClickPast";
import { CabinetTreeActionDeleteIcon, MenuNavPeoplesIcon, SfFilterCopyIcon, SfFilterMenuIcon } from "../Public/markup/icons";
import Button from "../core/Button";
import useObjectState from '../../hooks/useObjectState';
import { standartErrorToast, standartSuccessToast } from '../toasts';
import { ActionButtons } from '../CompanyEmployers';
import PanModal from '../core/PanModal';
import { UserCreateModal } from '../../pages/Tree';
import useModalWithData from '../../hooks/useModalWithData';



const CompanyBid = () => {

  const { data: { departments = [], employees = [], positions = [], access_list = [] }, isLoading, dataSetter, send } = useApi({
    payload: ["panpartner:company.ajax", "getConfirmations",]
  })

  const setEmployerValues = (employeerId, values) => {
    dataSetter('employees', (prev) => {
      const tmp = [...prev];
      const index = tmp.findIndex((item) => item.id === employeerId);
      tmp[index] = { ...tmp[index], ...(typeof values === "function" ? values(tmp[index]) : values) };
      return tmp;
    })
  }
  const handleEditEmploye = (employeeValues = {}) => {
    const params = {
      employeeId: employeeValues?.id,
      departmentId: employeeValues?.departmentId,
      position: employeeValues?.position, //director || agent уточнить, есть ущё post у пользователя
      comment: employeeValues?.comment || "",
      access: employeeValues?.access,
    }

    setEmployerValues(employeeValues.id, employeeValues)
    // send(['panpartner:company.ajax', "editEmployee", params]).then(standartSuccessToast, standartErrorToast)
  }

  const approveConfirmation = (approve, record) => {

    const params = {
      confirmationId: record.confirmation_id,
      departmentId: record.departmentId,
      access: record.access,
      approve

    }
    send(["panpartner:company.ajax", "approveConfirmation", params])
      .then(r => {
        dataSetter("employees", prev => ([...prev].filter(prev => prev.id !== record.id)))
        standartSuccessToast(r)
      }, standartErrorToast)
  }

  const [selectedObjects, setSelectedObjects] = useState([]);
  const selectItems = id => setSelectedObjects(prev => uniq(prev.concat(id)))
  const deselectItems = id => setSelectedObjects(prev => without(prev, ...(Array.isArray(id) ? id : [id])))
  const toggleItems = (id, checked) => checked ? selectItems(id) : deselectItems(id)

  const getColumns = () => [

    {
      title: "Сотрудник",
      dataIndex: "fullName",
      key: "fullName",
      render: (fullName, { phone, email }) =>
        <div>
          <div><b>{fullName}</b></div>
          <div>{phone}</div>
          <div>{email}</div>
        </div>
    },
    {
      title: "Отдел",
      dataIndex: "",
      key: "",
      width: 300,
      render: (dep, record) =>
        <Dropdown
          options={departments}
          placeholder="Выбрать"
          onChange={(v) => handleEditEmploye({ ...record, departmentId: v })}
          value={record.departmentId}
          titleKey="name"
        />
    },
    // {
    //   title: "Должность",
    //   dataIndex: "position",
    //   key: "position",
    //   render: (position, record) =>
    //     <Dropdown
    //       options={positions}
    //       placeholder="Выбрать"
    //       onChange={(v) => handleEditEmploye({ ...record, position: v })}
    //     />
    // },
    {
      title: "Доступ",
      dataIndex: "access",
      key: "access",
      width: 300,
      render: (access, record) => {
        return <Dropdown
          options={access_list}
          placeholder="Выбрать"
          valueKey="value"
          onChange={(v) => handleEditEmploye({ ...record, access: v })}
          value={record.access}
        />
      }
    },

    {
      title: "",
      dataIndex: "lastView",
      key: "lastView",
      width: 80,
      render: (text, record, isActive) => {
        return (
          <div className="crm-table__sf-action">
            <ActionButtons
              onClickLeft={() => approveConfirmation(true, record)}
              onClickRight={() => approveConfirmation(false, record)}
            // addComponents={<CabinetTreeActionDeleteIcon onClick={() => approveConfirmation(false, record)} />}
            />
          </div>
        )
      },
    },

  ]

  if (isLoading) return <Preloader loading />;
  return (
    <>


      <div className="company-bid crm-table crm-table_filters">
        <Table
          rowKey="id"
          showSorterTooltip={false}
          columns={getColumns()}
          dataSource={employees}
          pagination={false}
          locale={{ emptyText: "ничего не найдено" }}
          customPagination={true}
        />

        {/* <div className="company-employers__actions">
        <div>
          <label className="hp__form-label text">
            <span>Назначить отдел</span>
          </label>
          <Dropdown
            options={[{"title": "Руководитель", "value": "director"}, {"value": "agent", "title": "Агент"}]}
            placeholder="Выбрать"
            wrapperClass=""
          />
        </div>
        <div>
          <label className="hp__form-label text">
            <span>Назначить должность</span>
          </label>
          <Dropdown
            options={[{"title": "Руководитель", "value": "director"}, {"value": "agent", "title": "Агент"}]}
            placeholder="Выбрать"
            wrapperClass=""
          />
        </div>
        <div className="">
          <label className="hp__form-label text">
            <span>Доступ</span>
          </label>
          <Dropdown
            options={[{"title": "Руководитель", "value": "director"}, {"value": "agent", "title": "Агент"}]}
            placeholder="Выбрать"
            wrapperClass=""
          />
        </div>
        <div className="company-employers__actions-btns">
          <Button buttonType="primary_gray">
            Применить
          </Button>
        </div>
        <div className="company-employers__actions-btns">
          <Button buttonType="line">Отменить</Button>
        </div>
      </div> */}
      </div>
    </>
  )
}

export default CompanyBid
